import { Button, Layout, theme, Form, Spin, Empty, notification } from "antd";

import React, { useCallback, useEffect, useState } from "react";
import "../CreateRole/CreateRole.css";

import { Row, Col } from "antd";
import { Link, useNavigate } from "react-router-dom";
import TopHeader from "../../common/TopHeader/TopHeader";
import Sidebar from "../../common/Sidebar/Sidebar";
// import FooterDashboard from "../../common/FooterDashboard/FooterDashboard";
import TextArea from "antd/es/input/TextArea";
import CompliantApi from "../../common/Apis/CompliantApi";
import { WechatOutlined } from "@ant-design/icons";
import { List, Avatar } from "antd";

const ReplyComplain = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { Content } = Layout;
  const urlParams = new URLSearchParams(window.location.search);
  const id = urlParams.get("id");
  const TName = urlParams.get("TName");
  const [loadings, setLoadings] = useState(false);
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleSubmit = (data) => {
    setLoadings(true);

    let foramData = JSON.stringify({
      compliantId: CompliantsDetails?.id,
      email: CompliantsDetails?.createdBy,
      reply: data?.compliantReply,
      tenantApiKey: decodedToken?.tenantApiKey,
      tenantDTO: {
        id: decodedToken?.tenantId,
        tenantApiKey: decodedToken?.tenantApiKey,
      },
    });
    CompliantApi.CompliantReplay(foramData)
      .then((response) => {
        setLoadings(false);
        console.log(response);
        getCompliantReplys();
        PageLoading();
        form.resetFields();
        notification.open({
          message: <span style={{ fontWeight: "bold" }}>Successfully</span>,
          description: "Successfully Replied",
          closeIcon: false,
          duration: 3,
          style: {
            backgroundColor: "#b3ffb3",
            color: "green",
          },
        });
        // return navigate("/masters/departments");
      })
      .catch((err) => {
        if (err.apiError.status) {
          setLoadings(false);
          notification.open({
            message: <span style={{ fontWeight: "bold" }}>Error</span>,
            description: err.apiError.message,
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#fff2f0",
              color: "red",
            },
          });
        }
      });
  };

  const [CompliantsDetails, setCompliantsDetails] = React.useState([]);
  const getCompliantDetails = useCallback(() => {
    CompliantApi.CompliantDetails(id)
      .then((response) => {
        console.log(response);
        setCompliantsDetails(response.payload);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const [CompliantsReplys, setCompliantsReplys] = React.useState([]);
  const getCompliantReplys = useCallback(() => {
    CompliantApi.CompliantReplys(id)
      .then((response) => {
        console.log(response);
        setCompliantsReplys(response.payloadDto);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const [isLoading, setIsLoading] = useState(false);
  const PageLoading = useCallback(() => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
  }, []);

  useEffect(() => {
    getCompliantDetails();
    getCompliantReplys();
    PageLoading();
  }, [getCompliantDetails, getCompliantReplys, PageLoading]);

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout>
        <TopHeader />
        {isLoading && (
          <div className="spinner-overlay" id="spinnerOverlay">
            <div className="spinner"></div>
          </div>
        )}

        <Content
          className="form-content nav-content"
          style={{
            margin: "16px 16px 0",
            padding: "30px",
            background: colorBgContainer,
          }}
        >
          <Form
            form={form}
            name="nest-messages"
            layout="vertical"
            className="FormClass"
            onFinish={handleSubmit}
          >
            <>
              <Row gutter={24} className="pt-3">
                <Col span={24}>
                  {TName && (
                    <>
                      <h5>
                        <b>Tenant Name</b> : {TName}
                      </h5>
                    </>
                  )}
                  <h5>
                    <b>Replies</b> :
                  </h5>
                  <h5>{CompliantsDetails?.customerCompliant}</h5>
                </Col>
              </Row>
              <Row gutter={16} className="pt-3">
                <Col span={16}>
                  {CompliantsReplys && (
                    <List
                      itemLayout="horizontal"
                      locale={{
                        emptyText: (
                          <Empty
                            image={<WechatOutlined className="EmptyData" />}
                            description="No replies"
                          />
                        ),
                      }}
                      dataSource={CompliantsReplys}
                      renderItem={(item) => (
                        <List.Item className="chat-list-item">
                          {item.createdBy !== "admin@admin.com" ? (
                            <>
                              <div className="chat-list-item-content w-100">
                                <div
                                  style={{
                                    marginLeft: 12,
                                    color: "rgba(0, 0, 0, 0.45)",
                                  }}
                                >
                                  {new Date(item.createdDate).toLocaleString()}
                                </div>
                              </div>
                              <div className="chat-list-item-avatar d-flex">
                                <List.Item.Meta
                                  title={item.createdBy}
                                  description={item.reply}
                                />
                                <Avatar className="mx-2">
                                  {item.createdBy[0]}
                                </Avatar>
                              </div>
                            </>
                          ) : (
                            <>
                              <List.Item.Meta
                                avatar={<Avatar>{item.createdBy[0]}</Avatar>}
                                title={item.createdBy}
                                description={item.reply}
                                style={{
                                  alignSelf:
                                    item.name === "John"
                                      ? "flex-start"
                                      : "flex-end",
                                }}
                              />
                              <div
                                style={{
                                  marginLeft: 12,
                                  color: "rgba(0, 0, 0, 0.45)",
                                }}
                              >
                                {new Date(item.createdDate).toLocaleString()}
                              </div>
                            </>
                          )}
                        </List.Item>
                      )}
                    />
                  )}
                  <Form.Item
                    name="compliantReply"
                    label="Corrective Action / Maintenance Action Taken *"
                    className="text-lable pt-2"
                    rules={[
                      {
                        required: true,
                        message: "Please enter Reply.",
                      },
                    ]}
                  >
                    <TextArea
                      className="form-control control-input p-3"
                      rows={5}
                      style={{ resize: "none" }}
                    ></TextArea>
                  </Form.Item>
                </Col>
              </Row>

              <div className="d-flex justify-content-end pt-5">
                <Link
                  type="primary"
                  to={""}
                  onClick={handleGoBack}
                  className="btn btn-primary btn-back"
                >
                  Back
                </Link>

                <Button
                  type="primary"
                  htmlType="submit"
                  className="btn btn-primary btn-save"
                >
                  Reply {loadings == true && <Spin className="px-2" />}
                </Button>
              </div>
            </>
          </Form>
        </Content>
        {/* <FooterDashboard /> */}
      </Layout>
    </Layout>
  );
};
export default ReplyComplain;
